import React from 'react';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createAssistantOffice } from 'api/assistants';
import { getOffices } from 'api/offices';
import { useParams } from 'react-router-dom';
import SelectInput from 'components/Form/SelectInput';
import Button from 'components/Button';
import Popup from 'components/Popup';

export default function AssistantAddOfficesPopup({
    visible,
    setVisible,
    present = [],
}) {

    const { assistantId } = useParams();
    const cache = useQueryClient();

    const { mutate: update } = useMutation({
        mutationKey: ['updateOffice'],
        mutationFn: createAssistantOffice,
        onSuccess: () => {
            cache.invalidateQueries(['assistants', assistantId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error updating assistant-office:", error);
        }
    });

    const { data: offices } = useQuery({
        queryKey: ['offices'],
        queryFn: async () => await getOffices({}),
    });


    const selectOptions = offices?.map(office => {
        return {
            value: office._id,
            label: office.name
        }
    });


    function onSubmitHandler(e) {
        e.preventDefault();
        return update({
            id: assistantId,
            data: {
                office: e.target.office.value
            }
        });
    }

    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form onSubmit={onSubmitHandler}>
                {selectOptions &&
                    <SelectInput
                        label="Seleziona ufficio"
                        name="office"
                        options={selectOptions?.filter(office => !present.includes(office.value))}
                        required
                    />
                }

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button submit>Conferma</Button>
                </div>
            </form>
        </Popup>
    )
}
